var map = {
	"./Bar/Big.svg": 25210,
	"./Bar/Huge.svg": 97933,
	"./Bar/Micro.svg": 52124,
	"./Bar/Small.svg": 7765,
	"./Check/Big.svg": 55473,
	"./Check/Huge.svg": 96852,
	"./Check/Micro.svg": 19939,
	"./Check/Small.svg": 12358,
	"./Cross/Big.svg": 61761,
	"./Cross/Huge.svg": 21348,
	"./Cross/Micro.svg": 76371,
	"./Cross/Small.svg": 15318,
	"./Node/Big.svg": 80269,
	"./Node/Huge.svg": 30072,
	"./Node/Micro.svg": 775,
	"./Node/Small.svg": 86802,
	"./Ring/Big.svg": 64439,
	"./Ring/Huge.svg": 50189,
	"./Ring/Micro.svg": 56181,
	"./Ring/Small.svg": 18528,
	"./Spinner/Big.svg": 43786,
	"./Spinner/Huge.svg": 51965,
	"./Spinner/Micro.svg": 59948,
	"./Spinner/Small.svg": 11973,
	"./Triangle/Big.svg": 20257,
	"./Triangle/Huge.svg": 82020,
	"./Triangle/Micro.svg": 16211,
	"./Triangle/Small.svg": 25577,
	"./WeirdBurger/Big.svg": 16957,
	"./WeirdBurger/Huge.svg": 94248,
	"./WeirdBurger/Micro.svg": 44119,
	"./WeirdBurger/Small.svg": 7522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73972;